export default "__VITE_ASSET__CrN5_QeL__"